const sessionStorageKeys = ["token", "user", "credito", "saldo"];

export function hasSessionToken() {
  const token = localStorage.getItem("token");
  return Boolean(token && token !== "null" && token !== "undefined");
}

export function clearStoredSession() {
  sessionStorageKeys.forEach((key) => localStorage.removeItem(key));
}

export function redirectToWebsiteLogin() {
  if (globalThis.location.pathname !== "/login") {
    globalThis.location.href = "/login";
  }
}
